import { useContext, useEffect, useState } from 'react'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { listarSuporte } from '../../services/suporte'
import menuOpcoes from '../../interfaces/propsMenuOpcoes'
import SubMenuOpcoes from '../SubMenuOpcoes'
import '../../styles/menuopcoes.css'

function MenuSuporte (props: menuOpcoes) {

    const { atualizarInformacoes } = useContext(ModalEstadoContext)

    const [atendimento, setAtendimento] = useState(0)
    const [bug, setBug] = useState(0)

    const [subMenu, setSubMenu] = useState(false)

    function exibirSubmenu () {
        setSubMenu (subMenu => !subMenu)
    }

    useEffect(() => {
        
        const buscarSuporte = async () => {

            const paramsSuporte = {
                pagina: 1,
                termo: '',
                tipo: 'suporte',
                status: 'sem análise'
            }

            const paramsBug = {
                pagina: 1,
                termo: '',
                tipo: 'bug',
                status: 'sem análise'
            }

            const promisses = [
                await listarSuporte(paramsSuporte),
                await listarSuporte(paramsBug)
            ]
            
            try {

                const resposta = await Promise.all(promisses)

                const suporte = resposta[0]
                const bug = resposta[1]

                if(suporte.status === 200) {
                    setAtendimento(suporte.data.length)
                }

                if(bug.status === 200) {
                    setBug(bug.data.length)
                }
                
            } catch (error) {
                
            }
        }

        buscarSuporte ()

    }, [atualizarInformacoes])

    return (
        <div>
            <div id = 'menuOpcoes' onClick={exibirSubmenu}>
                {<img id = 'iconeMenu' src= {props.icone} alt = {props.alt}></img>}
                <p id = 'tituloMenu'>{props.titulo}</p>
                {(atendimento + bug) !== 0 ? <h2>{atendimento + bug}</h2> : null}
            </div>
            <div id = 'submenuOpcoes'>
                {subMenu && <SubMenuOpcoes redirect = {'/ajuda?tipo=suporte'} texto = 'Solicitar Atendimento' notificacao={atendimento === 0 ? null : atendimento}/>}
                {subMenu && <SubMenuOpcoes redirect = {'/ajuda?tipo=bug'} texto = 'Reportar Problema' notificacao={bug === 0 ? null : bug}/>}
                {subMenu && <SubMenuOpcoes redirect = {'/ajuda?tipo=sugestão'} texto = 'Sugestão de Melhoria' notificacao={null}/>}
            </div>
        </div>
    )
}

export default MenuSuporte
